import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, CheckCircleIcon } from 'lucide-react';
export function SafetySection() {
  const notes = ['Laser therapy is not appropriate for every person or every condition.', 'A consultation is needed first.', 'Results vary.', 'This page is educational and does not replace medical advice.', 'If symptoms are severe, sudden, worsening, or related to a major injury, seek appropriate medical care.', 'Please do not submit Protected Health Information through the website form.'];
  return <section className="py-20 md:py-24 bg-brand-gray-light" data-id="element-233">
      <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-md border-2 border-gray-200 p-8 md:p-10" data-id="element-235">
          <div className="flex flex-col sm:flex-row items-start gap-5 mb-8 border-b border-gray-200 pb-6" data-id="element-236">
            <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center text-amber-600 flex-shrink-0" data-id="element-237">
              <AlertTriangleIcon className="w-7 h-7" data-id="element-238" />
            </div>
            <div data-id="element-239">
              <h2 className="text-2xl md:text-3xl font-black text-brand-navy mb-2 leading-tight" data-id="element-240">
                Important Safety Information
              </h2>
              <p className="text-sm md:text-base text-gray-600" data-id="element-241">
                Please review before scheduling a consultation.
              </p>
            </div>
          </div>

          <ul className="space-y-4" data-id="element-242">
            {notes.map((note, idx) => <li key={idx} className="flex items-start gap-3 text-brand-charcoal" data-id="element-243">
                <CheckCircleIcon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-244" />
                <span className="leading-relaxed font-medium text-sm md:text-base" data-id="element-245">
                  {note}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}